import dayjs from "dayjs";
import type { License } from "~/modules/license/models/License.interface";
import { LicenseStatus } from "~/modules/license/models/LicenseStatus.enum";

/**
 * Return the status of the licence [active|warning|expired]
 * @param license
 */
export function getLicenseStatus(license: License) {
  let licenseStatus: LicenseStatus = LicenseStatus.ACTIVE;

  const now = dayjs();
  if (license.toleratedUntil && license.expiresAt) {
    const toleratedUntil: dayjs.Dayjs = dayjs(license.toleratedUntil);
    const expiresAt: dayjs.Dayjs = dayjs(license.expiresAt);
    if (
      (now.isSame(expiresAt) || now.isAfter(expiresAt)) &&
      now.isBefore(toleratedUntil)
    ) {
      licenseStatus = LicenseStatus.WARNING;
    } else if (now.isAfter(toleratedUntil)) {
      licenseStatus = LicenseStatus.EXPIRED;
    }
  } else if (license.expiresAt) {
    const expiresAt: dayjs.Dayjs = dayjs(license.expiresAt);
    if (now.isAfter(expiresAt) || now.isSame(expiresAt)) {
      licenseStatus = LicenseStatus.EXPIRED;
    }
  }

  return licenseStatus;
}
